import { render, staticRenderFns } from "./TableYesNo.vue?vue&type=template&id=470cf866"
import script from "./TableYesNo.vue?vue&type=script&lang=ts"
export * from "./TableYesNo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports